import { useState } from "react";
import { toast } from "sonner";
import { Target } from "lucide-react";
import { api } from "@/lib/api";

// Daily keepers goal the Keepers button fills toward. Saved on the account so phone and computer match.
export default function KeepersGoal({ goal, onSaved, testid }) {
  const [edit, setEdit] = useState(false);
  const [v, setV] = useState(goal ? String(goal) : "");
  const save = async (e) => {
    e.preventDefault();
    const g = Math.max(0, Math.round(Number(v) || 0));
    try {
      await api.put("/keepers/goal", { goal: g });
      onSaved(g);
      setEdit(false);
      toast.success(g ? `Daily keepers goal set to $${g.toLocaleString()}` : "Daily goal turned off");
    } catch {
      toast.error("Couldn't save the goal");
    }
  };
  if (!edit) {
    return (
      <button type="button" onClick={() => setEdit(true)} className="inline-flex items-center gap-1 text-[11px] font-semibold text-emerald-700 underline-offset-2 hover:underline" data-testid={`${testid}-goal-edit`}>
        <Target className="h-3 w-3" /> {goal ? `Goal $${goal.toLocaleString()}` : "Set a daily goal"}
      </button>
    );
  }
  return (
    <form onSubmit={save} className="inline-flex items-center gap-1" data-testid={`${testid}-goal-form`}>
      <span className="text-[11px] font-semibold text-slate-600">$</span>
      <input autoFocus value={v} onChange={(e) => setV(e.target.value.replace(/\D/g, "").slice(0, 7))} inputMode="numeric" placeholder="500"
        className="h-7 w-20 rounded-md border border-slate-300 px-2 font-mono text-base sm:text-xs" data-testid={`${testid}-goal-input`} />
      <button type="submit" className="rounded-full bg-emerald-600 px-2.5 py-1 text-[11px] font-semibold text-white" data-testid={`${testid}-goal-save`}>Save</button>
      <button type="button" onClick={() => setEdit(false)} className="text-[11px] text-slate-500" data-testid={`${testid}-goal-cancel`}>Cancel</button>
    </form>
  );
}
